import { useEffect, useState } from 'react';
import { RotateDevice, WarningSVG } from '../../assets/SVGAssets';
import Header from '../../components/header/Header';

import decor1 from '../../assets/images/icon3.webp';

import './rotateDeviceWarning.css';

export default function RotateDeviceWarning() {
    const isLandscape = () =>
        window.matchMedia('(orientation:landscape)').matches;
    const [orientation, setOrientation] = useState(
        isLandscape() ? 'landscape' : 'portrait',
    );

    const onWindowResize = () => {
        clearTimeout(window.resizeLag);
        window.resizeLag = setTimeout(() => {
            delete window.resizeLag;
            setOrientation(isLandscape() ? 'landscape' : 'portrait');
        }, 200);
    };

    useEffect(
        () => (
            // eslint-disable-next-line
            onWindowResize(),
            window.addEventListener('orientationchange', onWindowResize),
            () =>
                window.removeEventListener('orientationchange', onWindowResize)
        ),
        [],
    );

    return (
        <div
            className="rotateDeviceWrapper"
            style={{ display: orientation === 'landscape' ? 'none' : 'block' }}>
            <Header />
            <div className="rotateDeviceBorders">
                <div className="rotateDevice-border left"></div>
                <div className="rotateDevice-border right"></div>
            </div>

            <div className="rotateDeviceTitle">
                <WarningSVG />
            </div>

            <div className="rotateDeviceContent">
                <h1>oops!</h1>

                <p>quiz will not display correctly in portrait mode</p>
                <RotateDevice />
                <p className="bold">please rotate your device</p>
            </div>

            <img className="decor1" src={decor1} alt="decor" />
        </div>
    );
}
